
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"79","height":"79","viewBox":"0 0 79 79","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M41.675 1.057c.053.051.104.103.154.157l6.42 6.91 9.175-2.26c2.045-.505 4.104.771 4.6 2.85.017.072.033.144.046.216l1.692 9.416 8.883 2.999c1.997.674 3.078 2.866 2.415 4.896-.023.07-.047.139-.074.208l-3.504 8.976 5.803 7.38c1.314 1.671 1.047 4.108-.597 5.444a3.86 3.86 0 01-.174.133l-7.676 5.537.923 9.492c.207 2.128-1.323 4.024-3.416 4.234l-.218.016-9.316.39-4.35 8.551c-.967 1.9-3.266 2.643-5.134 1.66a3.784 3.784 0 01-.19-.108l-8.078-4.864-8.076 4.864c-1.81 1.09-4.147.482-5.22-1.358a3.807 3.807 0 01-.105-.194l-4.353-8.55-9.313-.391c-2.102-.088-3.736-1.892-3.65-4.03l.016-.22.92-9.492-7.673-5.537c-1.716-1.238-2.12-3.656-.902-5.4.042-.06.086-.12.131-.177l5.802-7.38-3.502-8.976c-.776-1.989.18-4.24 2.136-5.029a3.82 3.82 0 01.204-.075l8.88-2.998L16.05 8.93c.378-2.104 2.363-3.498 4.432-3.113.072.013.143.029.213.046l9.174 2.262 6.421-6.911a3.766 3.766 0 015.385-.157z","fill":"#F44747"}}),_c('path',{attrs:{"d":"M37.375 45.875h4.25v4.25h-4.25v-4.25zm0-17h4.25v12.75h-4.25v-12.75zm2.104-10.625c-11.73 0-21.229 9.52-21.229 21.25s9.499 21.25 21.229 21.25c11.751 0 21.271-9.52 21.271-21.25s-9.52-21.25-21.271-21.25zM39.5 56.5c-9.392 0-17-7.608-17-17s7.608-17 17-17 17 7.608 17 17-7.608 17-17 17z","fill":"#fff"}})])
          )
        }
      }
    